import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { PURGE } from 'redux-persist';

import './stylesheets/style.scss';
import { fetchWizardData, fetchStepsData } from './actions/actions';

import { Loader } from 'sg-styleguide';

// main app
import Wizard from './containers/wizard';
import { store, persistor } from './store';

// Render the wizard.
ReactDOM.render(
	<Provider store={store}>
    	<PersistGate loading={<Loader/>} persistor={persistor}>
			<Wizard />
    	</PersistGate>
	</Provider>,
	document.getElementById('app')
);

if ( /[?&]purge-store=/.test(window.location.href) ) {
    store.dispatch({ 
        type: PURGE,
        key: window.wizardData.persist_key,
        result: () => null
    });

    const newUrl = window.location.href.split('&purge-store=');

    window.history.pushState('name', '', newUrl[0]);

}

// Dispatch events,
store.dispatch(fetchWizardData());
store.dispatch(fetchStepsData());
